import { forwardRef, type TextareaHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "min-h-[56px] resize-y rounded-md border border-stone-300 bg-white px-3 py-[0.55rem] text-[0.88rem] text-stone-800 transition-all placeholder:text-stone-400 focus-visible:border-ind-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ind-500/15",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
